import { DeleteOutlined, DownloadOutlined, DragOutlined, EditOutlined, LinkOutlined, EyeOutlined, LockOutlined, PlusOutlined, ProfileOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Upload, UploadFile, UploadProps } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { ColumnsType } from 'antd/es/table';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import Link from 'antd/lib/typography/Link';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { chatLuongKPI, idNhomKPI, layTenTienDoKPI, tienDoKPI, trangThaiKPI, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { ChiTietKPICaNhan, ImportFileKPI, NhomKPICaNhan } from '../../models/kpi/KPICaNhan';
import { importFileKPICaNhan, layMauImportKPI, lienKetChiTietKPICaNhan } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import NhanVienPhongBanSelectBox from '../utils/NhanVienPhongBanSelectBox';
import _ from "lodash";
import { renderSpanCongViec } from './kpiHelper';

const SortableItem = SortableElement((props: any) => <tr {...props} />);
const SortableContainerMain = SortableContainer((props: any) => <tbody {...props} />);

const DragHandle = SortableHandle(() => (
    <DragOutlined style={{ cursor: 'pointer' }} rev={undefined} />
));
const EditChiTietKPITab = ({ idNhanVien, tieuDe, source, trangThai, thoiGian, isLDPhong, hasLDPhuTrach, disabled, valid, showError, onChange }:
    {
        idNhanVien: number, tieuDe: string, source: NhomKPICaNhan, trangThai: number, thoiGian: Dayjs, isLDPhong: boolean, hasLDPhuTrach: boolean, disabled: boolean, valid: boolean, showError: boolean, onChange: (data: NhomKPICaNhan, showErr: boolean) => void
    }) => {

    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.KPI.ChiTietKPI,
        Links.KPI.ThemKPI,
        Links.KPI.LanhDaoPhongDuyet,
        Links.KPI.LanhDaoPhuTrachDuyet]
    );
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);

    const props: UploadProps = {
        multiple: true,

        beforeUpload: (file) => {
            const maxSize = 20 * 1024 * 1024;

            if (file.size > maxSize) {
                alert("Tệp tin đính kèm không được vượt quá 20MB");
                return Upload.LIST_IGNORE;
            }

            setFileList((prev) => {
                const newFileList = [...prev, file];

                source.dsTaiLieu = newFileList;
                onChange(source, showError);

                return newFileList;
            });

            return false;
        },

        onRemove: (file) => {
            let newIdsTaiLieuXoa: number[] = [];
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                newIdsTaiLieuXoa = [...idsTaiLieuXoa, id];
                setIdsTaiLieuXoa(newIdsTaiLieuXoa);
            }
            setFileList((prev) => {
                const newFileList = prev.filter((item) => item.uid !== file.uid);
                source.idsTaiLieuXoa = newIdsTaiLieuXoa;

                source.dsTaiLieu = newFileList;
                onChange(source, showError);

                return newFileList;
            });

            return true;
        },

        fileList,
    };
    useEffect(() => {
        if (!source?.dsTaiLieu) return;

        const files: UploadFile[] = source.dsTaiLieu.map((item: any) => {
            if (item.idTaiLieu) {
                return {
                    uid: `${item.idTaiLieu}tailieu`,
                    name: item.tenTep,
                    status: "done",
                    url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                };
            }

            return item;
        });

        setFileList(files);
    }, [source?.dsTaiLieu]);
    const [isEdit, setIsEdit] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const [showModalNhanVien, setShowModalNhanVien] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showErrorLienKet, setShowErrorLienKet] = useState<number>(0);

    const [showModal, setShowModal] = useState<boolean>(false);
    const [file, setFile] = useState<any>()
    const setFormLienKetModal = (value: ChiTietKPICaNhan) => {
        if (value.tenCongViec == null || value.tenCongViec == "") {
            setShowErrorLienKet(value.id);
            setShowModalNhanVien(false);
        } else {
            setShowErrorLienKet(0);
            form.setFieldsValue({
                "idNhanVienChon": null,
                "thangNam": thoiGian,
                "idNhomKPI": source.id,
                "tenCongViec": value.tenCongViec,
                "thoiGianGiao": value.thoiGianGiao != null ? dayjs(value.thoiGianGiao) : null,
                "thoiGianYeuCauHoanThanh": value.thoiGianYeuCauHoanThanh != null ? dayjs(value.thoiGianYeuCauHoanThanh) : null,
                "chatLuong": value.chatLuong,
                "tienDo": value.tienDo,
                "diemCaNhan": value.diemCaNhan,
                "isTieuDe": value.isTieuDe,
            });
            setShowModalNhanVien(true);
        }
    }
    const tableColumnsRead: ColumnsType<ChiTietKPICaNhan> = [
        {
            title: "",
            key: "sort",
            dataIndex: "sort",
            width: "10px",
            className: "drag-visible",
            render: (value, record, index) => {
                return (
                    <DragHandle />
                );
            }
        },
        {
            title: "STT",
            width: "8px",
            key: "thutu",
            dataIndex: "thutu",
            className: "text-center",
            render: (value, record, index) => {
                if (record.isTieuDe === 1) {
                    return <label>{record.thuTuStr}</label>;
                }
                return record.thuTuStr;
            }
        },
        {
            title: "Nội dung",
            key: "tenCongViec",
            dataIndex: "tenCongViec",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 9 : 1,
            }),
            className: "drag-visible",
            render: (value, record, index) => {
                if (!value && (showError || showErrorLienKet == record.id)) {
                    return (
                        <>
                            <span className="text-red float-left">Tên công việc bắt buộc nhập</span>
                        </>
                    );
                } else {
                    return renderSpanCongViec(record, trangThai);
                }
            }
        },
        {
            title: "Thời gian giao",
            key: "thoiGianGiao",
            dataIndex: "thoiGianGiao",
            className: "text-center drag-visible",
            width: "145px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return dateCommon.formatDate(value, "dd/MM/yyyy");
            }
        },
        {
            title: "TG Yêu cầu",
            key: "thoiGianYeuCauHoanThanh",
            dataIndex: "thoiGianYeuCauHoanThanh",
            className: "text-center drag-visible",
            width: "145px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return dateCommon.formatDate(value, "dd/MM/yyyy");
            }
        },
        {
            title: "Chất lượng CV",
            key: "chatLuong",
            dataIndex: "chatLuong",
            className: "text-center drag-visible",
            width: "95px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return record.chatLuong ? "Tốt" : "Sai sót";
            }
        },
        {
            title: "Tiến độ thực hiện",
            key: "tienDo",
            dataIndex: "tienDo",
            className: "text-center drag-visible",
            width: "7%",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return layTenTienDoKPI(record.tienDo);
            }
        },
        {
            title: "Chấm điểm (điểm trừ, điểm cộng)",
            key: "",
            dataIndex: "",
            className: "text-center",
            colSpan: 3,
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 3,
            }),
            children: [
                {
                    title: "Cá nhân",
                    key: "diemCaNhan",
                    dataIndex: "diemCaNhan",
                    className: "text-center drag-visible",
                    width: "5%",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        return record.diemCaNhan == 0 ? "" : record.diemCaNhan;
                    }
                },
                {
                    title: "LĐ phòng",
                    key: "diemLanhDaoPhong",
                    dataIndex: "diemLanhDaoPhong",
                    className: "text-center drag-visible",
                    width: "8px",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        return record.diemLanhDaoPhong == 0 ? "" : record.diemLanhDaoPhong;
                    }
                },
                {
                    title: "LĐ PTP",
                    key: "diemLanhDaoPhuTrach",
                    dataIndex: "diemLanhDaoPhuTrach",
                    className: "text-center drag-visible",
                    width: "8px",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        return record.diemLanhDaoPhuTrach == 0 ? "" : record.diemLanhDaoPhuTrach;
                    }
                },
            ]
        },
        {
            title: "Ghi chú",
            key: "ghiChu",
            dataIndex: "ghiChu",
            className: "drag-visible",
            width: "200px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return <span>{value}</span>;
            }
        },

    ];

    const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
        if (oldIndex !== newIndex) {
            let temp = [...source.chiTiet];
            const item = temp.splice(oldIndex, 1);
            temp = [...temp.slice(0, newIndex), ...item, ...temp.slice(newIndex)];
            source.chiTiet = temp;
            onChange(source, false);
        }
    };
    interface DraggableBodyRowProps {
        className: any;
        style: any;
        ["data-row-key"]: any;
    }
    const DraggableBodyRow = ({ className, style, ...restProps }: DraggableBodyRowProps) => {
        const index = (source?.chiTiet || [])?.map((x: ChiTietKPICaNhan, idx: number) => { x.key = idx; return x; }).findIndex((x: any) => x.key === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };

    const DraggableContainer = (props: any) => (
        <SortableContainerMain
            useDragHandle
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...props}
        />
    );
    const tableColumns: ColumnsType<ChiTietKPICaNhan> = [
        {
            title: "Nội dung",
            key: "tenCongViec",
            dataIndex: "tenCongViec",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 9 : 1,
            }),
            render: (value, record, index) => {                
                const handleChange = _.debounce(function(e) {
                    record.tenCongViec = e.target.value;
                    onChange(source, showError);
                }, 1000);
                if (!value && (showError || showErrorLienKet == record.id)) {
                    return (
                        <>
                            <TextArea
                                autoSize
                                style={record.isTieuDe == 1 ? {
                                    fontWeight: 'bold'
                                } : {}}
                                status="error"
                                id={`noidung-${record?.id}-${index}`}
                                defaultValue={value}
                                onChange={handleChange}
                            />
                            <div className="ant-form-item-explain-error float-left">Tên công việc bắt buộc nhập</div>
                        </>
                    );
                } else {
                    if (record.macDinh || record.idCha > 0 || record.idNVGiao > 0) {
                        return renderSpanCongViec(record, trangThai);
                    }
                    return (
                        <TextArea
                            style={record.isTieuDe == 1 ? {
                                fontWeight: 'bold'
                            } : {}}
                            autoSize
                            id={`noidung-${record?.id}-${index}`}
                            defaultValue={value}
                            onChange={handleChange}
                        />
                    );
                }
            }
        },
        {
            title: "Thời gian giao",
            key: "thoiGianGiao",
            dataIndex: "thoiGianGiao",
            className: "text-center",
            width: "145px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                if (record.macDinh || record.idCha > 0 || record.idNVGiao > 0)  return dateCommon.formatDate(value, "dd/MM/yyyy");
                return (
                    <DatePicker
                        changeOnBlur={true}
                        suffixIcon={null}
                        allowClear={false}
                        value={dayjs(value)}
                        picker="date"
                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                        onChange={(e: any) => {
                            record.thoiGianGiao = e.$d;
                            onChange(source, showError);
                        }}
                    />
                );
            }
        },
        {
            title: "TG Yêu cầu",
            key: "thoiGianYeuCauHoanThanh",
            dataIndex: "thoiGianYeuCauHoanThanh",
            className: "text-center",
            width: "145px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                if (record.macDinh || (record.idNVGiao > 0 && !record.choSuaThoiGianHT)) return dateCommon.formatDate(value, "dd/MM/yyyy");
                return (
                    <DatePicker
                        suffixIcon={null}
                        changeOnBlur={true}
                        allowClear={false}
                        value={dayjs(value)}
                        picker="date"
                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                        onChange={(e: any) => {
                            record.thoiGianYeuCauHoanThanh = e.$d;
                            onChange(source, showError);
                        }}
                    />
                );
            }
        },
        {
            title: "Chất lượng CV",
            key: "chatLuong",
            dataIndex: "chatLuong",
            className: "text-center",
            width: "95px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return (
                    <Radio.Group
                        onChange={(value: any) => {
                            record.chatLuong = value.target.value;
                            onChange(source, showError);
                        }}
                        value={record.chatLuong ?? 1}
                    >
                        <Radio className="row" value={1}>Tốt</Radio>
                        <Radio className="row" value={0}>Sai sót</Radio>
                    </Radio.Group>
                );
            }
        },
        {
            title: "Tiến độ thực hiện",
            key: "tienDo",
            dataIndex: "tienDo",
            className: "text-center",
            width: "7%",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                if (source.id == idNhomKPI.noiQuy) {
                    if (record.macDinh) return layTenTienDoKPI(record.tienDo);
                    return (
                        <Select onChange={(value: any) => {
                            if (value == tienDoKPI.tre) {
                                record.tienDo = value;
                                record.diemCaNhan = -4;
                                source.chiTiet[index].diemCaNhan = -4;

                                var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemCaNhan || 0), 0);
                                source.tuDanhGia = diem < 0 ? 0 : diem;
                                onChange(source, showError);
                            }
                            else {
                                record.tienDo = value;
                                record.diemCaNhan = 0;
                                source.chiTiet[index].diemCaNhan = 0;

                                var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemCaNhan || 0), 0);
                                source.tuDanhGia = diem < 0 ? 0 : diem;
                                onChange(source, showError);
                            }
                        }}
                            value={record.tienDo ?? 1}
                        >
                            <Select.Option value={tienDoKPI.dung}>Đúng</Select.Option>
                            <Select.Option value={tienDoKPI.tre}>Trễ</Select.Option>
                            <Select.Option value={tienDoKPI.loi}>Lỗi</Select.Option>
                        </Select>
                    );
                } else if (source.id == idNhomKPI.chuyenMon) {
                    return (
                        <Select onChange={(value: any) => {
                            if (value == tienDoKPI.tre) {
                                record.tienDo = value;
                                record.diemCaNhan = -4;
                                source.chiTiet[index].diemCaNhan = -4;

                                var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemCaNhan || 0), 0);
                                source.tuDanhGia = diem < 0 ? 0 : diem;
                                onChange(source, showError);
                            }
                            else {
                                record.tienDo = value;
                                record.diemCaNhan = 0;
                                source.chiTiet[index].diemCaNhan = 0;

                                var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemCaNhan || 0), 0);
                                source.tuDanhGia = diem < 0 ? 0 : diem;
                                onChange(source, showError);
                            }
                        }}
                            value={record.tienDo ?? 1}
                        >
                            <Select.Option value={tienDoKPI.truoc}>Trước</Select.Option>
                            <Select.Option value={tienDoKPI.dung}>Đúng</Select.Option>
                            <Select.Option value={tienDoKPI.dangThucHien}>Đang TH</Select.Option>
                            <Select.Option value={tienDoKPI.tre}>Trễ</Select.Option>
                        </Select>
                    );
                }
                else {
                    return (
                        <Select
                            allowClear
                            placeholder="Chọn"
                            value={record.tienDo == tienDoKPI.khongCo ? undefined : record.tienDo}
                            onChange={(value) => {
                                record.tienDo = value ?? tienDoKPI.khongCo;
                                onChange(source, showError);
                            }}
                        >
                            <Select.Option value={tienDoKPI.truoc}>Trước</Select.Option>
                        </Select>
                    );
                }
            }
        },
        {
            title: "Chấm điểm (điểm trừ, điểm cộng)",
            key: "",
            dataIndex: "",
            className: "text-center",
            colSpan: 3,
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 3,
            }),
            children: [
                {
                    title: "Cá nhân",
                    key: "diemCaNhan",
                    dataIndex: "diemCaNhan",
                    className: "text-center",
                    width: "5%",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        const handleChange = _.debounce(function (e) {
                            let value = e;

                            if (value == null) {
                                value = 0;
                            }
                            if (source.id == idNhomKPI.diemCong && value !== 0) {
                                value = Math.min(5, Math.max(1, value));
                            }

                            record.diemCaNhan = value;
                            source.chiTiet[index].diemCaNhan = value;
                            var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemCaNhan || 0), 0);
                            source.tuDanhGia = diem < 0 ? 0 : diem;
                            onChange(source, showError);
                        }, 1000);
                        if (!record.macDinh && (((trangThai <= trangThaiKPI.lanhDaoPhongTuChoi && idNhanVien == user.idNhanVien)
                            || (user.isLanhDaoPhong && idNhanVien == user.idNhanVien && trangThai <= trangThaiKPI.lanhDaoPhuTrachTuChoi)))) {
                            return (
                                <InputNumber
                                    style={{ width: "100%" }}
                                    id={`diemCaNhan-${record?.id}-${index}`}
                                    value={record.diemCaNhan === 0 ? undefined : record.diemCaNhan}
                                    onChange={handleChange}
                                    className="hide-arrow"
                                />
                            );
                        }
                        else {
                            return record.diemCaNhan == 0 ? "" : record.diemCaNhan;
                        }
                    }
                },
                {
                    title: "LĐ phòng",
                    key: "diemLanhDaoPhong",
                    dataIndex: "diemLanhDaoPhong",
                    className: "text-center",
                    width: "8px",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        if (source.id != idNhomKPI.diemCong && (trangThai >= trangThaiKPI.trinhLanhDaoPhong && trangThai <= trangThaiKPI.lanhDaoPhuTrachTuChoi && user.isLanhDaoPhong)) {
                            return (
                                <InputNumber
                                    style={{ width: "100%" }}
                                />
                            );
                        }
                        else {
                            return record.diemLanhDaoPhong == 0 ? "" : record.diemLanhDaoPhong;
                        }
                    }
                },
                {
                    title: "LĐ PTP",
                    key: "diemLanhDaoPhuTrach",
                    dataIndex: "diemLanhDaoPhuTrach",
                    className: "text-center",
                    width: "8px",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        if (source.id != idNhomKPI.diemCong && (trangThai >= trangThaiKPI.trinhLanhDaoPhuTrach && trangThai <= trangThaiKPI.lanhDaoDonViTuChoi && menu[Links.KPI.LanhDaoPhuTrachDuyet])) {
                            return (
                                <InputNumber
                                    style={{ width: "100%" }}
                                />
                            );
                        }
                        else {
                            return record.diemLanhDaoPhuTrach == 0 ? "" : record.diemLanhDaoPhuTrach;
                        }
                    }
                },
            ]
        },
        {
            title: source.id == idNhomKPI.chuyenMon ? (
                <div>
                    <div>Ghi chú</div>
                    <div style={{ fontSize: 12, color: '#888' }}>
                        Giải trình tiến độ & lý do thay đổi điểm
                    </div>
                </div>
            ) : "Ghi chú",
            key: "ghiChu",
            dataIndex: "ghiChu",
            width: "200px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                const handleChange = _.debounce(function(e) {
                    record.ghiChu = e.target.value;
                    onChange(source, showError);
                }, 1000);
                return (
                    <TextArea
                        autoSize
                        defaultValue={value}
                        id={`ghiChu-${record?.id}-${index}`}
                        onChange={handleChange}
                    />
                );
            }
        },
        {
            title: "",
            key: "delete",
            dataIndex: "",
            width: "1%",
            className: "",
            render: (value, record, index) => {
                return (<>
                    <Row gutter={[8, 8]}>
                        {!record.macDinh ? (record.idCha > 0 || record.idNVGiao > 0 ? <Col span="24">
                            <Space>
                                <Button
                                    className="btn-outline-primary"
                                    icon={<LinkOutlined rev="" />}
                                    title="Liên kết đến KPI nhân viên khác"
                                    size="small"
                                    onClick={() => {
                                        setFormLienKetModal(record);
                                    }}
                                >
                                </Button>
                            </Space>
                        </Col>
                            : <Col span="24">
                                <Space>
                                    <Button
                                        className="btn-outline-primary"
                                        icon={<LinkOutlined rev="" />}
                                        title="Liên kết đến KPI nhân viên khác"
                                        size="small"
                                        onClick={() => {
                                            setFormLienKetModal(record);
                                        }}
                                    >
                                    </Button>
                                    <Button
                                        className="btn-outline-danger"
                                        icon={<DeleteOutlined rev="" />}
                                        size="small"
                                        title="xóa"
                                        onClick={() => {
                                            const newData = source.chiTiet.filter((item) => item.key !== record.key);
                                            const del = source.chiTiet.find((item) => item.key == record.key);
                                            var diem = (source.tuDanhGia ?? 0) - (del.diemCaNhan ?? 0);
                                            source.tuDanhGia = diem != null && diem < 0 ? 0 : diem;
                                            source.chiTiet = [...newData];
                                            setIsEdit(false);
                                            onChange(source, false);
                                            setTimeout(() => {
                                                setIsEdit(true);
                                            }, 1);
                                        }}
                                    >
                                    </Button>
                                </Space>
                            </Col>) : null}
                        <Col span="24">
                            <Space>
                                <Button
                                    className="btn-outline-success"
                                    title="Thêm mới tiêu đề"
                                    icon={<ProfileOutlined rev="" />}
                                    size="small"
                                    onClick={() => {
                                        const newItem = new ChiTietKPICaNhan();
                                        newItem.idNhomKPI = source.id;
                                        newItem.isTieuDe = 1;
                                        if (!source.chiTiet) {
                                            source.chiTiet = [];
                                        }
                                        // Tìm chỉ mục của dòng được bấm
                                        const clickedRowIndex = source.chiTiet.findIndex(item => item.key === record.key);
                                        // Chèn một dòng mới vào chỉ mục sau dòng được bấm
                                        if (clickedRowIndex !== -1) {
                                            source.chiTiet.splice(clickedRowIndex + 1, 0, newItem);
                                        }
                                        setIsEdit(false);
                                        onChange(source, false);
                                        setTimeout(() => {
                                            setIsEdit(true);
                                        }, 1);
                                    }}
                                >
                                </Button>
                                <Button
                                    className="btn-outline-warning"
                                    size="small"
                                    icon={<PlusOutlined rev="" />}
                                    title="Thêm mới công việc"
                                    onClick={() => {
                                        const newItem = new ChiTietKPICaNhan();
                                        newItem.idNhomKPI = source.id;
                                        newItem.thoiGianGiao = thoiGian.startOf('month').toDate();
                                        newItem.thoiGianYeuCauHoanThanh = thoiGian.endOf('month').toDate();
                                        newItem.chatLuong = chatLuongKPI.tot;
                                        if (source.id == idNhomKPI.diemCong) {
                                            newItem.tienDo = tienDoKPI.khongCo;
                                        } else {
                                            newItem.tienDo = tienDoKPI.dung;
                                        }
                                        newItem.isTieuDe = 0;
                                        if (!source.chiTiet) {
                                            source.chiTiet = [];
                                        }
                                        // Tìm chỉ mục của dòng được bấm
                                        const clickedRowIndex = source.chiTiet.findIndex(item => item.key === record.key);
                                        // Chèn một dòng mới vào chỉ mục sau dòng được bấm
                                        if (clickedRowIndex !== -1) {
                                            source.chiTiet.splice(clickedRowIndex + 1, 0, newItem);
                                        }
                                        //source.chiTiet = [...source.chiTiet, newItem];
                                        setIsEdit(false);
                                        onChange(source, false);
                                        setTimeout(() => {
                                            setIsEdit(true);
                                        }, 1);
                                    }}
                                ></Button>
                            </Space>
                        </Col>
                    </Row>
                </>
                )
            },
        },

    ];

    const [form] = Form.useForm();
    const taiFileMau = async () => {
        try {
            setIsLoading(true);
            var response = await layMauImportKPI();
            let link = document.createElement('a');
            link.download = `MauKPI.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setIsLoading(false);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const handleFileChange = (files: any) => {
        try {
            if (files.length > 0) {
                const selectedFile = files[0];
                if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    setFile(selectedFile);
                } else {
                    alert("Vui lòng chọn một file Excel (định dạng .xlsx).");
                }
            }
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }

        setShowModal(true);
    };

    const handleUpload = async () => {
        setShowModal(false);
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            var request: ImportFileKPI = {
                file: file,
                thoiGian: thoiGian
            }

            try {
                setIsLoading(true);
                var response = await importFileKPICaNhan(request);
                if (!Array.isArray(source.chiTiet)) {
                    source.chiTiet = [];
                }
                source.chiTiet = [...source.chiTiet, ...response];
                onChange(source, false);
                toast.success("Import dữ liệu kpi chuyên môn thành công");
                setFile(null);
                setIsLoading(false);
            } catch (error) {
                setShowModal(false);
                setFile(null);
                toast.error("File import không đúng định dạng. Vui lòng thử lại sau");
                setIsLoading(false);
            }
        } else {
            toast.error('Vui lòng chọn một tệp tin để tải lên.');
        }
    };

    const onFinish = async (values: any) => {
        dispatch(showLoadingScreen())
        setIsLoadingBtn(true);
        try {
            await lienKetChiTietKPICaNhan(values);
            toast.success("Liên kết KPI cá nhân thành công");
        } catch (error: any) {
            toast.error(error);
        }
        setIsLoadingBtn(false);
        setShowModalNhanVien(false);
        dispatch(hideLoadingScreen());
    }

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    return (<>
        {showModalNhanVien && <ModalTextForm title="Liên kết nội dung KPI đến nhân viên khác"
            hideFooter
            show={showModalNhanVien}
            handleClose={() => setShowModalNhanVien(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="tenCongViec" label="tên công việc"><Input /></Form.Item>
                <Form.Item hidden name="idNhomKPI" label="nhóm kpi"><Input /></Form.Item>
                <Form.Item hidden name="chatLuong" label="chất lượng"><Input /></Form.Item>
                <Form.Item hidden name="tienDo" label="tiến độ"><Input /></Form.Item>
                <Form.Item hidden name="diemCaNhan" label="điểm cá nhân"><Input /></Form.Item>
                <Form.Item hidden name="isTieuDe" label="is tiêu đề"><Input /></Form.Item>
                <Form.Item hidden
                    name="thangNam"
                    label="Tháng đánh giá"
                >
                    <DatePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        placeholder="Tháng đánh giá"
                        allowClear={false}
                        picker="month"
                        format={thangNamFormat}
                    />
                </Form.Item>
                <Form.Item hidden
                    name="thoiGianGiao"
                    label="Thời gian giao"
                >
                    <DatePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        value={form.getFieldValue('thoiGianGiao')}
                        allowClear={false}
                        locale={viVN}
                    />
                </Form.Item>
                <Form.Item hidden
                    name="thoiGianYeuCauHoanThanh"
                    label="Thời gian hoàn thành"
                >
                    <DatePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        value={form.getFieldValue('thoiGianYeuCauHoanThanh')}
                        allowClear={false}
                        locale={viVN}
                    />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Chọn nhân sự"
                            name="idNhanVienChon"
                            rules={[{ required: true, message: 'Vui lòng chọn nhân viên' }]}
                        >
                            <NhanVienPhongBanSelectBox idDonVi={user.idDonVi} noLanhDao onChange={(e: any) => { form.setFieldValue('idNhanVienChon', e.target.value); }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <Tabs
            tabBarExtraContent={
                <Space>
                    {
                        trangThai <= 0 && menu[Links.KPI.ThemKPI] && !valid && showError &&
                        <div style={{ color: "#ff4d4f" }}>Vui lòng thêm công việc</div>
                    }
                    {
                        source.id == idNhomKPI.chuyenMon &&
                        <>
                            <Button
                                onClick={() => setShowModal(true)}
                                type="primary"
                                loading={isLoading}
                                icon={<UploadOutlined rev="" />}>
                                Import file
                            </Button>
                            <Button
                                className="hrm-btn-success"
                                onClick={taiFileMau}
                                loading={isLoading}
                                icon=<DownloadOutlined rev="" />
                            >
                                Tải file mẫu
                            </Button>
                        </>
                    }
                </Space>}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: tieuDe,
                    children:
                        <div className="card">
                            <Row>
                                <Col span="24">
                                    {isEdit ?
                                        <Table
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            dataSource={(source.chiTiet || []).map((x: ChiTietKPICaNhan, idx: number) => { x.key = idx; return x; })}
                                            columns={tableColumns}
                                            pagination={false}
                                            rowKey="key"
                                        >
                                        </Table> :
                                        <Table
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            dataSource={(source.chiTiet || []).map((x: ChiTietKPICaNhan, idx: number) => { x.key = idx; return x; })}
                                            columns={tableColumnsRead}
                                            pagination={false}
                                            rowKey="key"
                                            components={{
                                                body: {
                                                    wrapper: DraggableContainer,
                                                    row: DraggableBodyRow,
                                                },
                                            }}
                                        >
                                        </Table>
                                    }
                                </Col>
                            </Row>
                            <Row className="m-2" gutter={24}>
                                {
                                    source.id == idNhomKPI.diemCong && (source.chiTiet || []).length > 0 && <Col span="16">
                                        <Upload {...props}>
                                            <Button title="Thêm tài liệu minh chứng điểm cộng" type="primary" icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                        </Upload>
                                    </Col>
                                }
                                {
                                    source.id != idNhomKPI.diemCong && <> <Col span="8">
                                        <Form.Item
                                            label="Tự đánh giá"
                                        >
                                            <InputNumber
                                                disabled={true}
                                                style={{ width: "100%" }}
                                                min={0}
                                                value={source?.tuDanhGia}
                                            />
                                        </Form.Item>
                                    </Col>
                                        {
                                            trangThai >= trangThaiKPI.trinhLanhDaoPhong && idNhanVien != user.idNhanVien &&
                                            <Col span="8">
                                                <Form.Item
                                                    label="Lãnh đạo phòng"
                                                >
                                                    {
                                                        ((trangThai == trangThaiKPI.trinhLanhDaoPhong || trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi)
                                                            || (trangThai == trangThaiKPI.lanhDaoDonViTuChoi && !hasLDPhuTrach))
                                                            && disabled && menu[Links.KPI.LanhDaoPhongDuyet]
                                                            ? <InputNumber
                                                                style={{ width: "100%" }}
                                                                min={0}
                                                                max={source?.diemChuan > 0 ? source?.diemChuan : 100}
                                                                value={source?.lanhDaoPhong}
                                                                onChange={(value: any) => {
                                                                    source.lanhDaoPhong = value;
                                                                    onChange(source, showError);
                                                                }}
                                                                className="hide-arrow"
                                                            />
                                                            : trangThai != trangThaiKPI.trinhLanhDaoPhong
                                                                ? source?.lanhDaoPhong > 0
                                                                    ? source?.lanhDaoPhong
                                                                    : ""
                                                                : ""
                                                    }
                                                </Form.Item>
                                            </Col>
                                        }
                                        {
                                            trangThai >= trangThaiKPI.trinhLanhDaoPhuTrach &&
                                            <Col span="8">
                                                <Form.Item
                                                    label="Lãnh đạo phụ trách"
                                                >
                                                    {
                                                        (trangThai == trangThaiKPI.trinhLanhDaoPhuTrach || trangThai == trangThaiKPI.lanhDaoDonViTuChoi)
                                                            && disabled && menu[Links.KPI.LanhDaoPhuTrachDuyet]
                                                            ? <InputNumber
                                                                style={{ width: "100%" }}
                                                                min={0}
                                                                max={source?.diemChuan > 0 ? source?.diemChuan : 100}
                                                                value={source?.lanhDaoPhuTrach}
                                                                onChange={(value: any) => {
                                                                    source.lanhDaoPhuTrach = value;
                                                                    onChange(source, showError);
                                                                }}
                                                                className="hide-arrow"
                                                            />
                                                            : trangThai != trangThaiKPI.trinhLanhDaoPhuTrach
                                                                ? source?.lanhDaoPhuTrach > 0
                                                                    ? source?.lanhDaoPhuTrach
                                                                    : ""
                                                                : ""
                                                    }
                                                </Form.Item>
                                            </Col>
                                        }</>}
                                {
                                    (trangThai <= 1 || (trangThai == trangThaiKPI.lanhDaoPhongTuChoi || trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi)) && menu[Links.KPI.ThemKPI] && !disabled &&
                                    <Col span={source.id == idNhomKPI.diemCong && (source.chiTiet || []).length > 0 ? "8" : "24"}>
                                        <Space className="float-right">
                                            {
                                                (source.chiTiet || []).length > 0 ?
                                                    <Link
                                                        className="hrm-btn hrm-btn-primary"
                                                        onClick={() => setIsEdit(!isEdit)}
                                                    >
                                                        {isEdit ? <> <LockOutlined rev="" /> Khóa</> : <> <EditOutlined rev="" /> Điều chỉnh</>}
                                                    </Link> : null
                                                }
                                                {source.id != idNhomKPI.diemCong &&
                                                    <Link
                                                        className="hrm-btn hrm-btn-success"
                                                        onClick={() => {
                                                            const newItem = new ChiTietKPICaNhan();
                                                            newItem.idNhomKPI = source.id;
                                                            newItem.isTieuDe = 1;
                                                            if (!source.chiTiet) {
                                                                source.chiTiet = [];
                                                            }
                                                            source.chiTiet = [...source.chiTiet, newItem];
                                                            onChange(source, false);
                                                        }}
                                                    >
                                                        <ProfileOutlined rev="" /> Tiêu đề
                                                    </Link>}
                                            <Link
                                                className="hrm-btn hrm-btn-warning"
                                                onClick={() => {
                                                    const newItem = new ChiTietKPICaNhan();
                                                    newItem.idNhomKPI = source.id;
                                                    newItem.thoiGianGiao = thoiGian.startOf('month').toDate();
                                                    newItem.thoiGianYeuCauHoanThanh = thoiGian.endOf('month').toDate();
                                                    newItem.chatLuong = chatLuongKPI.tot;
                                                    if (source.id == idNhomKPI.diemCong) {
                                                        newItem.tienDo = tienDoKPI.khongCo;
                                                    } else {
                                                        newItem.tienDo = tienDoKPI.dung;
                                                    }
                                                    newItem.isTieuDe = 0;
                                                    if (!source.chiTiet) {
                                                        source.chiTiet = [];
                                                    }
                                                    source.chiTiet = [...source.chiTiet, newItem];
                                                    onChange(source, false);
                                                }}
                                            >
                                                <PlusOutlined rev="" /> Thêm mới
                                            </Link>
                                        </Space>
                                    </Col>
                                }
                            </Row>
                        </div>
                }
            ]}
        />
        <ModalTextForm
            show={showModal}
            title="Chọn file"
            handleClose={() => setShowModal(false)}
            handleSave={handleUpload}
        >
            <Dropzone onDrop={handleFileChange} multiple={false}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <div {...getRootProps()}
                        className="hrm-dropzone-uploadfile"
                    >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                            <p>Kéo và thả tệp tin ở đây...</p>
                        ) : file ? (
                            <div>
                                <p>File đã chọn: {file?.name}</p>
                                <p>Kích thước: {file?.size} bytes</p>
                            </div>
                        ) : (
                            <p>Kéo và thả hoặc chọn một file Excel ở đây.</p>
                        )}
                    </div>
                )}
            </Dropzone>
        </ModalTextForm>
    </>
    );
};

export default EditChiTietKPITab;
